import React, { useState, useEffect } from 'react';
import Header from '../Header';
import '../../styles/Home/Hero.css';

const Hero = () => {
  const [currentSlide, setCurrentSlide] = useState(0);

  const backgroundImages = [
    '/assets/hero1.JPG',
    '/assets/hero2.JPG',
    '/assets/hero3.jpg',
    'https://images.unsplash.com/photo-1524492412937-b28074a5d7da?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=2071&q=80',
    'https://images.unsplash.com/photo-1602216056096-3b40cc0c9944?ixlib=rb-4.0.3&auto=format&fit=crop&w=2071&q=80'
  ];

  useEffect(() => {
    const slideInterval = setInterval(() => {
      setCurrentSlide((prevSlide) =>
        prevSlide === backgroundImages.length - 1 ? 0 : prevSlide + 1
      );
    }, 5000);

    return () => clearInterval(slideInterval);
  }, [backgroundImages.length]);

  const goToPrevSlide = () => {
    setCurrentSlide((prev) =>
      prev === 0 ? backgroundImages.length - 1 : prev - 1
    );
  };
  const goToNextSlide = () => {
    setCurrentSlide((prev) =>
      prev === backgroundImages.length - 1 ? 0 : prev + 1
    );
  };

  return (
    <section className="travelscape-hero-section">
      {/* Image Slider */}
      <div className="travelscape-hero-slider">
        {backgroundImages.map((image, index) => (
          <div
            key={index}
            className={`travelscape-hero-slide ${index === currentSlide ? 'active' : ''}`}
            style={{ backgroundImage: `linear-gradient(rgba(0, 0, 0, 0.2), rgba(0, 0, 0, 0.2)), url('${image}')` }}
          ></div>
        ))}
        <button
          className="travelscape-slider-btn travelscape-slider-btn-left"
          onClick={goToPrevSlide}
          aria-label="Previous Slide"
        >
          &#8592;
        </button>
        <button
          className="travelscape-slider-btn travelscape-slider-btn-right"
          onClick={goToNextSlide}
          aria-label="Next Slide"
        >
          &#8594;
        </button>
      </div>

      {/* Use the Header component */}
      <div style={{ position: 'relative', zIndex: 25 }}>
        <Header />
      </div>

      {/* Hero Content centered vertically */}
      <div className="travelscape-hero-content">
        <div className="container">
          {/* <h1 className="travelscape-hero-title">Join Travelscape To<br />Explore India's Soul</h1> */}
        </div>
      </div>

      {/* Stats bar always at bottom, outside slider/content */}
      <div className="travelscape-hero-bottom" style={{ zIndex: 10, position: 'absolute', width: '100%', left: 0, bottom: 0 }}>
        <div className="travelscape-stats-bar">
          <div className="travelscape-stat-horiz">
            <i className="fas fa-smile travelscape-stat-icon"></i>
            <span className="travelscape-stat-number">7000+</span>
            <span className="travelscape-stat-label">Happy Customers</span>
          </div>
          <div className="travelscape-stat-horiz">
            <i className="fas fa-star travelscape-stat-icon"></i>
            <span className="travelscape-stat-number">500+</span>
            <span className="travelscape-stat-label">5 Star Reviews</span>
          </div>
          <div className="travelscape-stat-horiz">
            <i className="fas fa-map-marker-alt travelscape-stat-icon"></i>
            <span className="travelscape-stat-number">500+</span>
            <span className="travelscape-stat-label">Tours Organized</span>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Hero;
